/**
 * O verde do Lucas, num lugar só e com os dois temas dentro.
 *
 * A cor aparece em quatro sítios que precisam combinar: o ícone do atalho
 * flutuante, o anel da pulsada, o ponto de status no cabeçalho do painel e o
 * ícone "Suporte" na sidebar. São o mesmo recurso visto de ângulos diferentes,
 * e foi a divergência entre dois deles que fez a duplicação saltar aos olhos.
 *
 * ## Por que são dois verdes, e não um
 *
 * Medido: `#40dea8` sobre um fundo branco dá 1.72 de contraste. É invisível.
 * O mesmo verde sobre o chip escuro dá 9.74. Um valor único teria que escolher
 * entre sumir no tema claro ou no escuro.
 *
 * Então o tom fecha no tema claro (`#17855f`, 4.61 sobre branco) e abre no
 * escuro. É o mesmo matiz: lê como a mesma cor, só não desaparece.
 *
 * ## Por que a classe inteira, e não o hex
 *
 * O Tailwind varre o código à procura das classes literais para gerar o CSS.
 * Um `text-[${COR}]` montado em tempo de execução não seria encontrado nem
 * gerado, e a cor simplesmente não sairia.
 */

/** Cor do ícone, nos dois temas. */
export const LUCAS_ACCENT_TEXT = "text-[#17855f] dark:text-[#40dea8]";

/** Preenchimento do anel da pulsada e do ponto de status. */
export const LUCAS_ACCENT_BG = "bg-[#17855f] dark:bg-[#40dea8]";

/**
 * A superfície do atalho flutuante, nos dois temas.
 *
 * Segue o tema como o painel da conversa, de propósito: os dois são a mesma
 * coisa e precisam parecer da mesma família. Preto fixo pesava na tela clara,
 * e branco fixo pesava na escura.
 *
 * O preenchimento quase não contrasta com a página em nenhum dos dois (1.07 no
 * claro), o que é normal: num chip pequeno quem desenha a silhueta é a BORDA e
 * a sombra, não o fundo. A borda é mais forte no escuro porque lá ela é a única
 * coisa separando o chip da página.
 */
export const LUCAS_SURFACE =
  "border border-black/10 bg-white dark:border-white/20 dark:bg-[#12131b]";

/** Os hex puros, para medições e para quem precisar do valor e não da classe. */
export const LUCAS_ACCENT_DARK = "#40dea8";
export const LUCAS_ACCENT_LIGHT = "#17855f";
